import { useIsFetching } from '@tanstack/react-query';
import { ExternalLink } from 'lucide-react';
import { useState } from 'react';
import { PageShell } from '../../components/common/PageShell';
import { DateRangePicker } from '../../components/ui/date-range-picker';
import { AcquireMetrics } from '../metrics/tabs/AcquireMetrics';
import styles from './AcquirePage.module.css';

const ACQUIRE_COPY = {
  title: 'Acquire',
  description: 'AI-powered ad campaign creation and management for Google and Meta',
  docs: 'API Docs',
};
export const AcquirePage = () => {
  const [selectedDays, setSelectedDays] = useState(0);
  const isFetching = useIsFetching({ queryKey: ['acquire-metrics', selectedDays] }) > 0;
  const actions = (
    <div className={styles.controls}>
      <a
        className={styles.docs}
        href="https://docs.embedreach.com/acquire/introduction"
        target="_blank"
        rel="noopener noreferrer"
        aria-label={ACQUIRE_COPY.docs}
        title={ACQUIRE_COPY.docs}>
        {ACQUIRE_COPY.docs}
        <ExternalLink aria-hidden />
      </a>
      <DateRangePicker
        selectedDays={selectedDays}
        onSelectDays={setSelectedDays}
        isLoading={isFetching}
      />
    </div>
  );
  return (
    <PageShell title={ACQUIRE_COPY.title} description={ACQUIRE_COPY.description} actions={actions}>
      <AcquireMetrics selectedDays={selectedDays} />
    </PageShell>
  );
};
